import HeaderComponent from "../header";
import DepositForm from "./depositForm";
import Kpis from "./kpis";
import RecentEnergyTransactions from "./recentEnergyTransactions";
import RecentTopup from "./recentTopup";
import EnergyRechargeForm from "./EnergyRechargeForm";
import { useCallback, useEffect, useState } from "react";
import apiCalls from "src/api/apiCalls";
import { isErrorMessage } from "../shared/error.message";

const EnergyDashBoard = () => {
    const breadCrumbList = [{ id: '1', bname: 'Energy', url: "" },]
    const [isTopupGridRefresh, setIsTopupGridRefresh] = useState(false);
    const [isEnergyGridRefresh, setIsEnergyGridRefresh] = useState(false);
    const [availableCredit, setAvailableCredit] = useState({ data: 0, loading: true, error: null });
    const [usedCredit, setUsedCredit] = useState({ data: 0, loading: true, error: null });
    const [days, setDays] = useState(1);
    useEffect(() => {
        availableCreditData();
    }, [isTopupGridRefresh, isEnergyGridRefresh]);
    useEffect(() => {
        usedCreditData();
    }, [isEnergyGridRefresh, days]);
    const availableCreditData = useCallback(async () => {
        setAvailableCredit(prevState => ({ ...prevState, loading: true, error: null }));
        try {
            const response = await apiCalls.getAvailableCredits();
            if (response.ok) {
                setAvailableCredit({ data: response.data, loading: false, error: null });
            } else {
                setAvailableCredit(prevState => ({
                    data: prevState.data && typeof prevState.data === 'number' ? prevState.data : 0,
                    loading: false,
                    error: isErrorMessage(response) || 'An error occurred while fetching available credit.'
                }));
            }
        } catch (err) {
            setAvailableCredit(prevState => ({
                data: prevState.data && typeof prevState.data === 'number' ? prevState.data : 0,
                loading: false,
                error: err.message || 'An error occurred while fetching available credit.'
            }));
        }
    }, [isTopupGridRefresh])
    const usedCreditData = async () => {
        setUsedCredit(prevState => ({ ...prevState, loading: true, error: null }));
        try {
            const response = await apiCalls.getUsedCredits(days);
            if (response.ok) {
                setUsedCredit({ data: response.data, loading: false, error: null });
            } else {
                setUsedCredit(prevState => ({
                    data: typeof prevState.data === 'number' ? prevState.data : 0,
                    loading: false,
                    error: isErrorMessage(response) || 'An error occurred while fetching Used Credit data.'
                }));
            }
        } catch (err) {
            setUsedCredit(prevState => ({
                data: typeof prevState.data === 'number' ? prevState.data : 0,
                loading: false,
                error: err.message || 'An error occurred while fetching Used Credit data.'
            }));
        }
    };

    const handleFilterChange = useCallback((filterValue) => {
        setDays(filterValue);
    },[])
    return (
        <div className=''>
            <HeaderComponent breadCrumbList={breadCrumbList} />
            <div className="energy-dashboard-container">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
                    {/* Left Panel: KPIs + Merchant Topup */}
                    <div className="md:col-span-8 col-span-12 border border-StrokeColor md:p-4 p-3 rounded-5 overflow-auto">
                        <div className="">
                            <Kpis creditData={availableCredit} usedCredit={usedCredit} handleFilterChange={handleFilterChange} days={days} />
                            <div className="md:col-span-2 mt-5">
                                <EnergyRechargeForm propsData={{ setIsEnergyGridRefresh, availableCredit }} />
                            </div>
                        </div>
                    </div>

                    {/* Right Panel: Deposit Form */}
                    <div className="md:col-span-4 col-span-12 flex flex-col items-center border border-StrokeColor p-4 rounded-5">
                        <DepositForm setIsTopupGridRefresh={setIsTopupGridRefresh} />
                    </div>
                </div>

                <RecentEnergyTransactions isEnergyGridRefresh={isEnergyGridRefresh} setIsEnergyGridRefresh={setIsEnergyGridRefresh} />
                <RecentTopup isTopupGridRefresh={isTopupGridRefresh} setIsTopupGridRefresh={setIsTopupGridRefresh} />
            </div>

        </div>
    )
}
export default EnergyDashBoard;